import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../login/withLoginModal';

type Props = WithLoginModalProps;

export const RawNavLoginButton: React.FC<Props> = ({ openLoginModal }) => (
  <button
    data-test-id="login-button"
    className="nav__item button clear secondary nav__button"
    id="nav_connection_button"
    data-source="header"
    onClick={() => {
      openLoginModal();
    }}
    type="button"
  >
    <FormattedMessage id="navigation/login/NavLoginButton.tsx/1" />
  </button>
);

export const NavLoginButton = withLoginModal(RawNavLoginButton);
